module.exports = __webpack_public_path__ + "static/media/loading.aecd4782.svg";